__turbopack_context__.v({
  "row": "TileRow-module-scss-module__hENfeW__row",
});
